import React, { ReactElement } from 'react';
import loadable from '@loadable/component';
import { useParams } from 'react-router';
import { NotFound } from '../loadable-elements/NotFound';

const NafCenterTypeSwitch = loadable(() => import('./NafCenterTypeSwitch'), {
  resolveComponent: (m) => m.NafCenterTypeSwitch,
});

export const NafCentersDocumentRoute = (): ReactElement => {
  const { slug } = useParams<{ slug?: string }>();
  if (!slug) {
    return <NotFound />;
  }
  return <NafCenterTypeSwitch slug={slug} />;
};
